import { gql } from "@apollo/client";
import { useSuspenseQuery } from "@apollo/client/react";

import Brands from "./Brands.graphql";

interface IBrand {
    id: string

    name: string

    legacyAlias: string
    legacyID: string
}

export default function useBrands() {
    return useSuspenseQuery<{ brands: IBrand[] }>(gql(Brands));
}
